import { z } from 'zod';

import { EscrowSettingId, PropertyId } from '../BrandedIds';
import { EscrowSettingInput } from '../loan/EscrowSetting';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateEscrowSettingEvent = BaseLoanEvent.extend({
  type: z.literal('updateEscrowSetting'),
  propertyId: PropertyId,
  escrowSettingId: EscrowSettingId.optional(), // TODO remove once migration is done
  newEscrowSetting: EscrowSettingInput,
});

export type UpdateEscrowSettingEvent = z.infer<typeof UpdateEscrowSettingEvent>;
